'use client'

import { useMutation } from "@tanstack/react-query"
import { API_Error, API_Success_Response } from "@/interfaces/api/response/api_response_types"
import { deleteUser } from "../requests/user"

export const useDeleteAccount = () => useMutation<API_Success_Response<undefined>, API_Error, { basicAuth: string }>({
    retry: false,
    mutationFn: deleteUser
})